import React, { useState } from 'react';

const YEARS_PER_PAGE = 25;

interface YearGridPanelProps {
    selectedYear: number;
    onSelect: (year: number) => void;
    style?: React.CSSProperties;
}

export const YearGridPanel = React.forwardRef<HTMLDivElement, YearGridPanelProps>(
    ({ selectedYear, onSelect, style }, ref) => {
        const [pageStart] = useState(() => Math.floor(selectedYear / YEARS_PER_PAGE) * YEARS_PER_PAGE);
        const years    = Array.from({ length: YEARS_PER_PAGE }, (_, i) => pageStart + i);
        const thisYear = new Date().getFullYear();

        return (
            <div ref={ref} className="calendar-year-panel" style={style}>
                <div className="calendar-year-grid">
                    {years.map(y => (
                        <button
                            key={y}
                            className={[
                                'calendar-year-item',
                                y === selectedYear                   ? 'calendar-year-item--selected' : '',
                                y === thisYear && y !== selectedYear ? 'calendar-year-item--today'    : '',
                            ].filter(Boolean).join(' ')}
                            onClick={() => onSelect(y)}
                        >
                            {y}
                        </button>
                    ))}
                </div>
            </div>
        );
    }
);
YearGridPanel.displayName = 'YearGridPanel';

export default YearGridPanel;

